import { Task } from '../../types/interfaces';

export const applyFilters = (tasks: Task[], filters: { global: string }) => {
  return tasks.filter((task) => {
    // Global filter logic
    if (filters.global) {
      const globalLower = filters.global.toLowerCase();
      if (!checkNestedProperties(task, globalLower)) return false;
    }
    return true; // If all filters are passed, include the task in the filtered results
  });
};
// Helper function to recursively check all properties for a match
const checkNestedProperties = (obj: any, searchText: string): boolean => {
  if (obj === null || obj === undefined) return false;

  if (typeof obj === 'string') {
    return obj.toLowerCase().includes(searchText);
  }

  if (typeof obj === 'object') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (checkNestedProperties(obj[key], searchText)) {
          return true;
        }
      }
    }
  }
  return false;
};

export const getPriorityStyle = (priority: string) => {
  switch (priority) {
    case 'Высокий':
      return { color: 'maroon', display: 'flex', alignItems: 'center' };
    case 'Средний':
      return { color: 'blue', display: 'flex', alignItems: 'center' };
    case 'Низкий':
      return { color: '#A9A9A9', display: 'flex', alignItems: 'center' };
    default:
      return {};
  }
};

export const getPriorityClass = (
  selectedPriority: { label: string } | null
) => {
  if (!selectedPriority) {
    return 'priority-default';
  }

  switch (selectedPriority.label) {
    case 'Высокий':
      return 'priority-high';
    case 'Средний':
      return 'priority-medium';
    case 'Низкий':
      return 'priority-low';
    default:
      return 'priority-default';
  }
};
